import { createContext, useState } from 'react';

import PersonContactData from './PersonContactData';

export const PersonContactStateContext = createContext();

const PersonContactContextProvider = ({ children }) => {
  const stateHook = useState(PersonContactData.INITIAL_STATE);

  return (
    <PersonContactStateContext.Provider value={stateHook}>
      {children}
    </PersonContactStateContext.Provider>
  );
};

export default PersonContactContextProvider;